import { TypedSopNode } from "./_Base";
import { FileGLTFSopOperation } from "../../operations/sop/FileGLTF";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { Poly } from "../../Poly";
import { GeometryExtension } from "../../../core/loader/Geometry";
import { SopTypeFile } from "../../poly/registers/nodes/types/Sop";
const DEFAULT = FileGLTFSopOperation.DEFAULT_PARAMS;
class FileGLTFParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.url = ParamConfig.STRING(DEFAULT.url, {
      fileBrowse: { extensions: [GeometryExtension.GLB, GeometryExtension.GLTF] }
    });
    this.draco = ParamConfig.BOOLEAN(DEFAULT.draco);
    this.matrixAutoUpdate = ParamConfig.BOOLEAN(0);
    this.reload = ParamConfig.BUTTON(null, {
      callback: (node) => {
        FileGLTFSopNode.PARAM_CALLBACK_reload(node);
      }
    });
  }
}
const ParamsConfig = new FileGLTFParamsConfig();
export class FileGLTFSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return SopTypeFile.FILE_GLTF;
  }
  dispose() {
    super.dispose();
    Poly.blobs.clearBlobsForNode(this);
  }
  operation() {
    return this._operation = this._operation || new FileGLTFSopOperation(this.scene(), this.states, this);
  }
  async cook(input_contents) {
    const core_group = await this.operation().cook(input_contents, this.pv);
    this.setCoreGroup(core_group);
  }
  static PARAM_CALLBACK_reload(node) {
    node._paramCallbackReload();
  }
  _paramCallbackReload() {
    this.p.url.setDirty();
  }
}
